import { render } from "./AdminLayouts.vue?vue&type=template&id=ed176374&scoped=true"
import script from "./AdminLayouts.vue?vue&type=script&lang=js"
export * from "./AdminLayouts.vue?vue&type=script&lang=js"

import "./AdminLayouts.vue?vue&type=style&index=0&id=ed176374&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed176374"]])

export default __exports__